// This icon file is generated automatically.
var BanOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M511.62 52.54a459.2 459.2 0 10-.07 918.4 459.2 459.2 0 00.07-918.33zm0 85A372.48 372.48 0 01747.9 221.7L221.44 748.1a374.2 374.2 0 01290.18-610.56zm0 748.48a372.03 372.03 0 01-227.97-77.96l524.29-524.28a372.35 372.35 0 0177.88 227.96 374.2 374.2 0 01-374.2 374.28z" } }] }, "name": "ban", "theme": "outlined" };
export default BanOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/BanOutlined.js
// module id = 2044
// module chunks = 0